import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { ProductsServices } from '../../../products/services';

/**
 * Generated class for the DishTutorialSlidePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-product-tutorial-slide',
  templateUrl: 'product-tutorial-slide.html',
})
export class ProductTutorialSlidePage {

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public globals: Globals,
    public productsServices: ProductsServices) {
  }

  ionViewDidLoad() {
  }


  ionViewDidLeave() {
    this.closeLeave();
  }

  close() {
    this.globals.restaurant.tutorial_product = true;
    this.productsServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
      'tutorial_product': this.globals.restaurant.tutorial_product,
    }).then(() => {
      this.navCtrl.pop();
    });

  }

  closeLeave() {
    this.globals.restaurant.tutorial_product = true;
    this.productsServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
      'tutorial_product': this.globals.restaurant.tutorial_product,
    }).then(() => {
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/help/tutorial-slider/product-tutorial-slide/product-tutorial-slide.ts